import { useState } from 'react';
import { DashboardModal } from '@uppy/react';
import Uppy from '@uppy/core';
import XHRUpload from '@uppy/xhr-upload';
import { connect, type ConnectedProps } from 'react-redux';
import { API_URL, UPLOAD_URL } from '@/config';
import { user, setUpdatedUser } from '@/slices/user';
import { type RootState } from '@/store';
import { type DrawerContentProps } from '../../../state';

import '@uppy/core/dist/style.min.css';
import '@uppy/dashboard/dist/style.min.css';

type Props = ConnectedProps<typeof connector> & DrawerContentProps;

const FileUploadDrawer = ({ closeDrawer, user, setUpdatedUser }: Props) => {
  const [uppy] = useState(() => {
    const uppy = new Uppy({
      restrictions: { maxNumberOfFiles: 1, allowedFileTypes: ['image/*'] },
    }).use(XHRUpload, {
      endpoint: `${API_URL}/api/files/avatar/${user?.id}`,
      withCredentials: true,
    });

    uppy.on('complete', (result) => {
      const fullPath = result.successful?.[0]?.response?.body?.fullPath;
      const avatar = `${UPLOAD_URL}/${fullPath}`;

      setUpdatedUser({ avatar });
    });

    return uppy;
  });

  return (
    <DashboardModal
      uppy={uppy}
      open
      proudlyDisplayPoweredByUppy={false}
      note="Upload your avatar"
      onRequestClose={closeDrawer}
    />
  );
};

const connector = connect(
  (state: RootState) => ({
    user: user(state),
  }),
  {
    setUpdatedUser,
  },
);

export default connector(FileUploadDrawer);
